import {
  withTranslation,
} from 'react-i18next';

import RegattaCheckFieldsView from './RegattaCheckFieldsView';

const TranslatedComponent = withTranslation()(RegattaCheckFieldsView);

const Component = TranslatedComponent;

export default Component;
